import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';

const DataItemDatepicker = ({
                              fieldId,
                              placeholderText = '',
                              containerStyle = '',
                              sideLabelStyle = '',
                              inputContainerStyle = '',
                              sideLabel = null,
                              customClassName = 'form-control custom-data-item-textarea',
                            }) => {
  const handleChange = ({form, field}) => date => {
    form.setFieldValue(field.name, date);
  }

  return (
    <div className={containerStyle}>
      <div className={sideLabelStyle}>{sideLabel}</div>
      <div className={inputContainerStyle}>
        <Field
          id={fieldId}
          name={fieldId}
        >
          {({field, form}) => (
            <DatePicker
              value={dayjs(field.value)}
              className={customClassName}
              placeholder={placeholderText}
              onChange={date => handleChange({form, field})(date.$d)}
              locale={locale}
              format={'DD-MM-YYYY'}
              clearIcon={false}
              suffixIcon={false}
              showToday={false}
            />
          )}
        </Field>
      </div>
    </div>
  );
}

DataItemDatepicker.propTypes = {
  fieldId: PropTypes.string,
  placeholderText: PropTypes.node,
  onChange: PropTypes.func,
};

export default DataItemDatepicker;
